module.exports = __webpack_public_path__ + "img/img16.61a5194b.svg";